import React from "react";
import { RouterProvider } from "react-router-dom";
import routes from "./routes/routes";

import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "react-datepicker/dist/react-datepicker.css";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

dayjs.extend(buddhistEra);

function App() {
  return <RouterProvider router={routes} />;
}

export default App;
